import { useEffect, useRef } from "react";
import { Box, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TopSection from "./TopSection";
import Tabs from "./Tabs";
import { useRecruitmentProcess } from "hooks/useRecruitmentProcess";
import { useEducation } from "hooks/useEducation";
import { useExperiences } from "hooks/useExperiences";
import { useHistory } from "hooks/useHistory";
import { useSelector } from "react-redux";
import { useKeywordHighlight } from "hooks/useKeywordHighlight";

// matchedKeywords: the words the keyword search found on this profile, e.g. ["react", "λογιστής"].
// Only the list response has them, so they're passed in when opened from the listing.
export const View = ({ candidateId, isInDrawer, matchedKeywords }) => {
    const version = useSelector((state) => state.currentCandidate?.version);

    const containerRef = useRef(null);

    const { highlight } = useKeywordHighlight(containerRef);

    const { fetchExperiences } = useExperiences();
    const { getRecruitmentProcesses } = useRecruitmentProcess();
    const theme = useTheme();
    const { getEducations } = useEducation();
    const { getCandidateHistory } = useHistory();

    useEffect(() => {
        getRecruitmentProcesses(candidateId, 1, true);
        getEducations(candidateId);
        fetchExperiences(candidateId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidateId]);

    useEffect(() => {
        if (version) {
            getCandidateHistory(candidateId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [version]);

    useEffect(() => {
        highlight(matchedKeywords, {
            isCaseSensitive: false,
            isAccentSensitive: false,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchedKeywords]);

    return (
        <Box
            ref={containerRef}
            sx={{
                background: theme.palette.gray.light,
                height: "100%",
            }}
        >
            <TopSection
                sx={{
                    padding: "1rem 2rem",
                    width: "100%",
                    background: "white",
                }}
                isInDrawer={isInDrawer}
            />
            <Divider />
            <Tabs isInDrawer={isInDrawer} />
        </Box>
    );
};

export default View;
